// @import types
import { IHttpResponse } from 'app_types/httpTypes'
// @end

// @add your types
export enum CourseSchedulingModes {
  VIRTUAL = 'Virtual',
  ON_LINE = 'En linea',
  ON_SITE_ON_LINE = 'Presencial - En linea',
  ON_SITE = 'Presencial'
}

export interface INewCourseSchedulingMode {
  name: string,
  description: string
 }

 export interface ICourseSchedulingModeListItem extends INewCourseSchedulingMode {
  _id: string
}

export interface ICourseSchedulingModesHttpResponse extends IHttpResponse {
  courseSchedulingModes: ICourseSchedulingModeListItem[]
  total_register: number
  pageNumber: number
  nPerPage: number
}

export interface ICourseSchedulingModeHttpResponse extends IHttpResponse {
  courseSchedulingMode: INewCourseSchedulingMode
  total_register: number
  pageNumber: number
  nPerPage: number
}
//@end
